import Model from "@/models/Model";
import Company from "@/models/Company";

export default class AdcontrolProfile extends Model {
  static type = "adcontrolProfiles";

  name!: string;
  slug!: string;

  accountType!: string;
  clientType!: string;

  accountCompany!: Company;
  mediaSourceKind?: null | "msk_tv" | "msk_vod" | "msk_vod_and_tv";

  canAccessVod!: boolean;
}
